export default defineNuxtRouteMiddleware((to, from) => {
  const { $auth } = useNuxtApp()

  if (to.path === '/customer/login' && $auth.isLoggedIn.value) {
    return navigateTo({
      path: '/customer',
      query: to.query
    })
  }

  if (!$auth.isLoggedIn.value) {
    return navigateTo({
      path: '/customer/login',
      query: to.query
    })
  }
})